import { _ as s } from "./OrButton.vue_vue_type_script_lang-W1ictbKz.mjs";
import { resolveComponent as i, openBlock as o, createElementBlock as t, mergeProps as l, toHandlers as d, createElementVNode as n, normalizeClass as a, renderSlot as c, Fragment as u, createVNode as m, createBlock as p, createCommentVNode as v } from "vue";
import { _ as f } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const y = ["type", "activated", "disabled", "data-loading"], k = {
  key: 0,
  class: /* @__PURE__ */ a(["absolute"])
};
function g(e, b, $, B, C, h) {
  const r = i("OrLoader");
  return o(), t("button", l({
    ref: "root",
    class: e.rootStyles,
    type: e.type,
    activated: e.activated,
    disabled: e.disabled,
    "data-loading": e.loading
  }, d({
    ...e.isVue3 ? {} : e.$listeners,
    click: e.onClick,
    focus: e.onFocus,
    blur: e.onBlur
  }, !0)), [
    n("div", {
      class: a(e.contentContainerStyles)
    }, [
      n("div", {
        class: a(e.contentStyles)
      }, [
        c(e.$slots, "default")
      ], 2),
      e.loading ? (o(), t(u, { key: 0 }, [
        e.variant == "contained" || e.variant == "outlined" ? (o(), t("div", k, [
          m(r, {
            variant: "circular",
            color: "inherit",
            size: "s"
          })
        ])) : (o(), p(r, {
          key: 1,
          variant: "text",
          text: e.loadingText
        }, null, 8, ["text"]))
      ], 64)) : v("", !0)
    ], 2)
  ], 16, y);
}
const N = /* @__PURE__ */ f(s, [["render", g]]);
export {
  N as O
};
//# sourceMappingURL=OrButton-C_hXddAf.mjs.map
